<template>
  <div :class="containerClass">
    <IconButton
      v-if="isUpdateAvailable(item)"
      :class="iconButtonClass"
      :href="adBridgeSyncAgentUrl"
      rel="noopener noreferrer"
      target="_blank"
      title="Install a new Sync Agent"
    >
      <DownloadIcon />
    </IconButton>
    <IconButton
      :class="iconButtonClass"
      title="Delete"
      @click="handleDelete"
    >
      <TrashIcon />
    </IconButton>
  </div>
</template>
<script>
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapGetters, mapState } from 'vuex';
import DownloadIcon from 'public/img/icons/actions-down.svg?inline';
import IconButton from 'client/components/Buttons/IconButton.vue';
import TrashIcon from 'public/img/icons/trash.svg?inline';

const storeModule = StoreModuleMap[ItemTypeConsts.adBridgeAgent];

export default {
  name: 'AdBridgeSyncAgentActions',

  components: {
    DownloadIcon,
    IconButton,
    TrashIcon,
  },

  props: {
    containerClass: {
      type: String,
      default: '',
    },
    handleDelete: {
      type: Function,
      required: true,
    },
    iconButtonClass: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(storeModule, [
      'isUpdateAvailable',
    ]),

    ...mapState('SettingsModule', [
      'adBridgeSyncAgentUrl',
    ]),
  },
};
</script>
